<template>
  <v-container
    fluid
    fill-height
    :class="$vuetify.breakpoint.xsOnly ? 'container-menor' : ''"
  >
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm7 md5 lg4>
        <v-toolbar color="primary">
          <v-toolbar-title class="white--text"
            >Acesso ao Apisul Seguros</v-toolbar-title
          >
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-form ref="loginForm" v-model="loginFormValid">
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      label="E-mail"
                      id="campoEmailLogin"
                      v-model="loginModel.email"
                      :rules="regras.email"
                      placeholder="Digite o e-mail"
                      validate-on-blur
                      @keyup.enter="realizarLogin"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Senha:"
                      id="campoSenhaLogin"
                      v-model="loginModel.senha"
                      :rules="regras.senha"
                      :type="!verSenha ? 'password' : 'text'"
                      :append-icon="!verSenha ? 'visibility' : 'visibility_off'"
                      @click:append="() => (verSenha = !verSenha)"
                      @keyup.enter="realizarLogin"
                      placeholder="Digite a senha"
                      required
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              to="/EsqueciSenha"
              id="esqueciMinhaSenhaBtn"
              small
              flat
              color="primary"
              >Esqueci minha senha</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              @click.native="realizarLogin"
              id="fazerLoginBtn"
              :disabled="!loginFormValid"
              color="primary"
              >Fazer Login</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-snackbar
          :timeout="6000"
          :color="snackbarLogin.color"
          multi-line
          v-model="snackbarLogin.visivel"
        >
          {{ snackbarLogin.mensagem }}
          <v-btn
            id="fecharMensagemBtn"
            dark
            flat
            @click.native="snackbarLogin.visivel = false"
            >Fechar</v-btn
          >
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "login",
  data: () => {
    return {
      loginFormValid: false,
      snackbarLogin: {
        visivel: false,
        color: null,
        mensagem: ""
      },
      verSenha: false,
      loginModel: {
        email: "",
        senha: ""
      },
      regras: {
        email: [
          v => !!v || "Você não pode deixar este campo em branco",
          v =>
            /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,3})$/.test(
              v
            ) || "Formato de e-mail inválido"
        ],
        senha: [v => !!v || "Você não pode deixar este campo em branco"]
      }
    };
  },
  methods: {
    realizarLogin: function() {
      const self = this;
      if (self.$refs.loginForm.validate()) {
        self.$store.commit("startLoading");
        axios
          .post(
            `${process.env.URL_USUARIOMS}/v1/no-auth/login`,
            self.loginModel
          )
          .then(response => {
            const data = response.data;
            if(data.renovarSenha) {
              self.snackbarLogin.visivel = true;
              self.snackbarLogin.color = "#ff9800";
              self.snackbarLogin.mensagem =" A sua senha expirou, ela deve ser atualizada a cada 90 dias.\nVoce será direcionado(a) para a tela de cadastro de senha.";
              setTimeout(function(){
                self.$router.push(`RecuperarSenha/${data.token}?renovacao=true`)
                 }, 5000)
            }
            else if (data.sucesso) {
              localStorage.setItem("token", data.token);
              self.$router.push({
                name: "ListagemSolicitacoes",
                params: { login: true }
              });
            } else {
              self.snackbarLogin.visivel = true;
              self.snackbarLogin.color = "error";
              self.snackbarLogin.mensagem = data.mensagem;
            }
          })
          .catch(err => {
            const mensagemServidor =
              err.response &&
              err.response.data &&
              (err.response.data.message || err.response.data.mensagem);
            self.snackbarLogin.visivel = true;
            self.snackbarLogin.color = "error";
            self.snackbarLogin.mensagem =
              mensagemServidor ||
              "Algo inesperado ocorreu na aplicação. Contate o administrador";
          })
          .then(() => {
            self.$store.commit("endLoading");
          });
      }
    }
  }
};
</script>

<style scoped>
.container-menor {
  padding: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/login/Login.vue